// src/store/reducers/userTypeSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userType: '',
    type: {
        isNonCompany: false,
        isCompany: false,
        isHero: false,
        isSwitched: false,
    }
};

export const userTypeSlice = createSlice({
    name: 'userType',
    initialState,
    reducers: {
        editUserType: (state, action) => {
            const selectedType = action.payload;
            state.userType = selectedType;

            switch (selectedType) {
                case 'nonCompany':
                    state.type = {
                        isNonCompany: true,
                        isCompany: false,
                        isHero: false,
                        isSwitched: true
                    };
                    break;
                case 'company':
                    state.type = {
                        isNonCompany: false,
                        isCompany: true,
                        isHero: false,
                        isSwitched: true
                    };
                    break;
                case 'hero':
                    state.type = {
                        isNonCompany: false,
                        isCompany: true,
                        isHero: true,
                        isSwitched: true
                    };
                    break;
                default:
                    state.userType = '';
                    state.type = {
                        isNonCompany: false,
                        isCompany: false,
                        isHero: false,
                        isSwitched: false
                    };
                    break;
            }
        },

        resetUserType: (state) => {
            state.userType = '';
            state.type = {
                isNonCompany: false,
                isCompany: false,
                isHero: false,
                isSwitched: false
            };
        }
    }
});

export const { editUserType, resetUserType } = userTypeSlice.actions;
export default userTypeSlice.reducer;
